import { isArray } from './array';
export var isNumeric = function (value) {
    return value != null &&
        value != undefined &&
        !isArray(value) &&
        value !== '' &&
        !isNaN(Number(value.toString()));
};
//# sourceMappingURL=isNumeric.js.map